/* Verkooppunten locator.
   Filters, pagination, map switching and distance sorting, all client side -
   the store list is already in the markup, so there is nothing to fetch.

   Bound from document rather than at load, because the corporate pages
   re-render their sections and listeners attached to the old nodes would be
   thrown away. */
(function () {
  if (window.__ybnStores) return;
  window.__ybnStores = true;

  var MAP = 'https://www.google.com/maps?q=';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function state(root) {
    if (!root.__st) root.__st = { page: 1, origin: null };
    return root.__st;
  }

  function stores(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-store]'));
  }

  function matching(root) {
    var prov = root.querySelector('[data-filter="province"]');
    var city = root.querySelector('[data-filter="city"]');
    var p = prov ? prov.value : '';
    var c = city ? city.value : '';
    return stores(root).filter(function (el) {
      if (p && el.getAttribute('data-province') !== p) return false;
      if (c && el.getAttribute('data-city') !== c) return false;
      return true;
    });
  }

  function fillSelects(root) {
    var all = stores(root);
    var prov = root.querySelector('[data-filter="province"]');
    var city = root.querySelector('[data-filter="city"]');
    if (!prov || !city) return;

    var chosenProv = prov.value;
    var provs = [], cities = [];
    all.forEach(function (el) {
      var p = el.getAttribute('data-province');
      var c = el.getAttribute('data-city');
      if (p && provs.indexOf(p) === -1) provs.push(p);
      if (c && (!chosenProv || p === chosenProv) && cities.indexOf(c) === -1) cities.push(c);
    });
    provs.sort();
    cities.sort();

    // only the province list is static; rebuild the city list on every change
    if (!prov.__filled) {
      provs.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p; o.textContent = p;
        prov.appendChild(o);
      });
      prov.__filled = true;
    }

    var keep = city.value;
    while (city.options.length > 1) city.remove(1);
    cities.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c; o.textContent = c;
      city.appendChild(o);
    });
    if (cities.indexOf(keep) !== -1) city.value = keep;
  }

  function distance(a, b, c, d) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (c - a) * rad, dLon = (d - b) * rad;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a * rad) * Math.cos(c * rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }

  function render(root) {
    var st = state(root);
    var list = root.querySelector('[data-list]');
    var found = matching(root);

    if (st.origin) {
      found.sort(function (x, y) {
        var xa = parseFloat(x.getAttribute('data-lat')), xo = parseFloat(x.getAttribute('data-lng'));
        var ya = parseFloat(y.getAttribute('data-lat')), yo = parseFloat(y.getAttribute('data-lng'));
        if (isNaN(xa) || isNaN(xo)) return 1;
        if (isNaN(ya) || isNaN(yo)) return -1;
        return distance(st.origin.lat, st.origin.lng, xa, xo) - distance(st.origin.lat, st.origin.lng, ya, yo);
      });
      found.forEach(function (el) { list.appendChild(el); });
    }

    var per = parseInt(root.getAttribute('data-per-page'), 10) || 10;
    var pages = Math.max(1, Math.ceil(found.length / per));
    if (st.page > pages) st.page = pages;
    var from = (st.page - 1) * per, to = from + per;

    stores(root).forEach(function (el) { el.hidden = true; });
    found.forEach(function (el, i) { el.hidden = (i < from || i >= to); });

    // Dutch needs the singular form for one result, not "1 verkooppunten"
    var countBox = root.querySelector('.ybn-stores__count');
    var countText = root.querySelector('[data-count-text]');
    if (countBox && countText) {
      var tpl = found.length === 1
        ? countBox.getAttribute('data-count-one')
        : countBox.getAttribute('data-count-many');
      countText.innerHTML = String(tpl || '').replace('{n}', '<b>' + found.length + '</b>');
    }
    var empty = root.querySelector('[data-empty]');
    if (empty) empty.hidden = found.length !== 0;

    var cur = root.querySelector('[data-cur]'), tot = root.querySelector('[data-total]');
    if (cur) cur.textContent = st.page;
    if (tot) tot.textContent = pages;

    each(root.querySelectorAll('[data-page]'), function (b) {
      var k = b.getAttribute('data-page');
      b.disabled = ((k === 'first' || k === 'prev') && st.page === 1) ||
                   ((k === 'last' || k === 'next') && st.page === pages);
    });

    var pager = root.querySelector('[data-pager]');
    if (pager) pager.hidden = pages < 2;

    if (found.length) showOnMap(root, found[0], false);
  }

  function showOnMap(root, item, scroll) {
    var map = root.querySelector('[data-map]');
    if (!map || !item) return;
    var q = item.getAttribute('data-query') || '';
    map.src = MAP + encodeURIComponent(q) + '&hl=nl&z=15&output=embed';
    if (scroll && window.matchMedia('(max-width: 899px)').matches) {
      map.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-filter]') : null;
    if (!sel) return;
    var root = sel.closest('[data-ybn-stores]');
    if (!root) return;
    if (sel.getAttribute('data-filter') === 'province') fillSelects(root);
    state(root).page = 1;
    render(root);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var show = t.closest('[data-show]');
    if (show) {
      var r1 = show.closest('[data-ybn-stores]');
      showOnMap(r1, show.closest('[data-store]'), true);
      return;
    }

    var pg = t.closest('[data-page]');
    if (pg) {
      var r2 = pg.closest('[data-ybn-stores]');
      var st = state(r2);
      var per = parseInt(r2.getAttribute('data-per-page'), 10) || 10;
      var pages = Math.max(1, Math.ceil(matching(r2).length / per));
      var k = pg.getAttribute('data-page');
      if (k === 'first') st.page = 1;
      if (k === 'prev') st.page = Math.max(1, st.page - 1);
      if (k === 'next') st.page = Math.min(pages, st.page + 1);
      if (k === 'last') st.page = pages;
      render(r2);
      return;
    }

    var geo = t.closest('[data-geo]');
    if (geo) {
      var r3 = geo.closest('[data-ybn-stores]');
      var msg = r3.querySelector('[data-geomsg]');
      if (!navigator.geolocation) {
        if (msg) { msg.hidden = false; msg.textContent = 'Locatie wordt niet ondersteund door deze browser.'; }
        return;
      }
      if (msg) { msg.hidden = false; msg.textContent = 'Locatie bepalen…'; }
      navigator.geolocation.getCurrentPosition(function (pos) {
        state(r3).origin = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        state(r3).page = 1;
        if (msg) msg.textContent = 'Gesorteerd op afstand tot uw locatie.';
        render(r3);
      }, function () {
        if (msg) msg.textContent = 'Locatie niet beschikbaar. Kies hierboven een provincie of plaats.';
      }, { timeout: 10000 });
    }
  });

  function boot() {
    each(document.querySelectorAll('[data-ybn-stores]'), function (root) {
      if (root.__booted) return;
      root.__booted = true;
      fillSelects(root);
      render(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
